export const SHOW_NOTIFICATION = 'IMP/SHOW_NOTIFICATION';

export const showNotification = (message, type = 'info', notificationOptions) => ({
  type: SHOW_NOTIFICATION,
  payload: {
    ...notificationOptions,
    type,
    message,
  },
});

export const HIDE_NOTIFICATION = 'IMP/HIDE_NOTIFICATION';
export const hideNotification = () => ({
  type: HIDE_NOTIFICATION,
});
